import {Link} from '@freckle/educator-materials/ts/components/link'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'

type Props = {
  linkText?: string
}

export function GetPremiumLink(props: Props) {
  const {linkText} = props
  const defaultedLinkText =
    linkText === undefined ? (
      <SafeTrans i18nKey="QUOTE_REQUEST_MODAL_LINK_REQUEST_QUOTE_LINK" />
    ) : (
      <>{linkText}</>
    )
  return (
    <Link href={Routes.pricing()} reactRouter>
      <strong>{defaultedLinkText}</strong>
    </Link>
  )
}
